module.exports = __webpack_public_path__ + "static1792652164348/img/xiaoheshang.2fa7237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiaoheshang.jpg
// module id = 895
// module chunks = 116